export default {"src":"/_next/static/media/smile.e4feb8a6.svg","height":132,"width":89,"blurWidth":0,"blurHeight":0};